module.exports = __webpack_public_path__ + "images/stickers/pete-busy@2x.35503951628d67da2c8a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-busy@2x.png
// module id = 6xjT
// module chunks = 24